import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import type { Maybe } from 'graphql/jsutils/Maybe.js';

@Entity()
export class KPIKPFReport extends MongoEntity {
  static override _class = 'KPIKPFReport';
  static override _collectionName = 'kpi-kpf-reports';

  @Field(type => Int)
  year: Maybe<number>;

  @Field(type => Int)
  month: Maybe<number>;

  @DataLoadedField(type => KPF, ({ kpfId }) => kpfId)
  kpf: Maybe<KPF>;

  @Field(type => String)
  kpfId: Maybe<string>;

  @Field(type => Int)
  activeUS: Maybe<number>;

  @Field(type => Int)
  activeOS: Maybe<number>;

  @Field(type => Float)
  attendancePercent: Maybe<number>;

  @Field(type => Int)
  newRegistrations: Maybe<number>;
}
